export const EMPTY = "EMPTY"
export const INITIALIZED = "INITIALIZED"
export const HOME = "/"
export const WEARE = "/weare"
